import { Component, computed, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { NotaFiscalService } from 'src/app/shared/services/nota-fiscal.service';
import { CarReplicaComponent } from '../../dashboard-adm/car/car-replica/car-replica.component';
import { CarDetalhesComponent } from '../../dashboard-adm/car/car-detalhes/car-detalhes.component';
import { TitleCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, TitleCasePipe, DatePipe]
})
export class NotificationComponent implements OnInit {
    numRenova;
    aguardando;
    constructor
    (
        protected notaFiscalService: NotaFiscalService,
        public dialogRef: MatDialogRef<NotificationComponent>,
        public dialog: MatDialog
    ) {  }

    ngOnInit() {
        this.numRenova  = this.notaFiscalService.carRenovaSignal();
        this.aguardando = this.notaFiscalService.carAguardandoSignal();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    openReplica(id) {
        this.dialog.open(CarReplicaComponent, { data: id }).afterClosed().subscribe(() => this.onNoClick());
    }

    openDetalhes(id) {
        this.dialog.open(CarDetalhesComponent, { data: id, autoFocus: false });
    }
}
